import { inject } from './inject';
import { ReservationSms as BaseReservationSms } from './ReservationSms';

export const ReservationSms = inject(BaseReservationSms);
